export enum ProductType {
  INTERNET = 'internet',
  TELEVISION = 'television',
  PHONE = 'voip_accounts',
  DNS_FILTER = 'dns_filter',
}
